
import { motion } from "framer-motion"
import { cn } from "@/lib/utils"

export function EmptyChildState() {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={cn(
        "p-4 sm:p-8 rounded-2xl text-center h-full",
        "bg-gradient-to-br from-slate-900/50 to-slate-800/50",
        "border border-slate-700/50",
        "backdrop-blur-xl"
      )}
    >
      <p className="text-slate-400">
        Select a child to view their daily activities
      </p>
    </motion.div>
  )
}
